import AkFeatureGates from '@atlaskit/feature-gate-js-client';

const checkFeatureGate = (feature: string): boolean => AkFeatureGates.checkGate(feature);

export default checkFeatureGate;
